/**
 * Cancels a specified setInterval() call.
 * @param	id	The ID of the setInterval() call, which you set to a variable,
 *   as in the following:
 * @langversion	3.0
 * @playerversion	Flash 9
 */
/**
 * Cancels a specified setInterval() call.
 * @param	id	The ID of the setInterval() call, which you set to a variable,
 *   as in the following:
 * @langversion	3.0
 * @playerversion	Flash 9
 */ export var clearInterval = window.clearInterval;
